import { render, staticRenderFns } from "./DisassembleOrderApprove.vue?vue&type=template&id=4fb3cee4"
import script from "./DisassembleOrderApprove.vue?vue&type=script&lang=js"
export * from "./DisassembleOrderApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports